import React, { useState, useEffect } from 'react'
import { useField, useFormikContext } from 'formik'
import Select from 'react-select'
import PropTypes from 'prop-types'

const DynamicSelect = ( { ...props } ) => {
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField( props )
  const [filteredData, setFilteredData] = useState( [] )

  const searchInfos = async ( search ) => {
    if ( search && search != '' ) {
      let data = await props.fetchFunction( {
        ...props.searchParams,
        search: search,
      } )
      if ( data.results ) {
        setFilteredData( data.results )
      } else {
        setFilteredData( data )
      }
    }
  }
  const searchData = ( search ) => {
    //essa função é necessária para que a cadeia de render carregue a tempo
    // e os parametros sejam carregados sem haver perda durante o processo
    searchInfos( search )
  }
  const fetchData = async () => {
    if ( props.searchParams ) {
      let data = await props.fetchFunction( props.searchParams )
      if ( data.results ) {
        setFilteredData( data.results )
      } else {
        setFilteredData( data )
      }
    } else {
      if ( filteredData.length == 0 ) {
        let data = await props.fetchFunction()
        if ( data?.results ) {
          setFilteredData( data.results )
        } else {
          setFilteredData( data )
        }
      }
    }
  }
  useEffect( () => {
    if ( props.waitPreSelection ) {
      return
    } else {
      fetchData()
    }
  }, [props.waitPreSelection] )

  const handleChange = ( val ) => {
    setFieldValue( field.name, val )
    if ( props.onChange ) {
      props.onChange( val )
    }
  }

  return (
    <div className={`input-type-style ${props.className}`}>
      <Select
        cacheOptions={true}
        {...field}
        {...props}
        styles={{
          control: ( baseStyles, state ) => ( {
            ...baseStyles,
            backgroundColor: props.backgroundColor,
          } ),
        }}
        isClearable
        placeholder={props.placeholder}
        getOptionValue={props.getOptionValue}
        getOptionLabel={props.getOptionLabel}
        loadingMessage={() => 'Carregando...'}
        noOptionsMessage={() =>
          props.noOptionsMessage || 'Nenhum resultado encontrado'
        }
        className={meta.error ? 'input-error red' : 'dropdown-style'}
        classNamePrefix="dropdown"
        onChange={( val ) => handleChange( val )}
        onInputChange={( a ) => searchData( a )}
        options={filteredData || []}
        isDisabled={props.disabled}
      />
      {props.label && (
        <label
          htmlFor={field.name}
          className={`
          input-label-style
          ${meta.error ? 'red' : 'dim'}
          ${props.required ? 'input-required' : ''}
        `}
        >
          {props.label}
        </label>
      )}
      {meta.error && <span className="input-helper red">{meta.error}</span>}
      {props.instructions && (
        <span className="input-helper">{props.instructions}</span>
      )}
    </div>
  )
}

DynamicSelect.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  instructions: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  backgroundColor: PropTypes.string,
}

DynamicSelect.defaultProps = {
  label: null,
  className: '',
  required: false,
  instructions: '',
  onChange: null,
  placeholder: 'Buscar...',
  backgroundColor: 'transparent'
}
export default DynamicSelect
